import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
import * as layout from '@/pages/layout';
import * as miniAppStore_setting_component_rightCard_component_dragCard_component_dragAndDropHOC from '@/pages/miniAppStore/setting/component/rightCard/component/dragCard/component/dragAndDropHOC/index';
import * as miniAppStore_setting_component_rightCard_component_dragCard_component_cardItem from '@/pages/miniAppStore/setting/component/rightCard/component/dragCard/component/cardItem/index';
import * as channelSetting_component_setUpChannel_component_jsApiAuthTable_useRowSelection from '@/pages/channelSetting/component/setUpChannel/component/jsApiAuthTable/useRowSelection';
import * as smartStudio_component_workflowManagement_component_viewFlowDetailsDrawer from '@/pages/smartStudio/component/workflowManagement/component/viewFlowDetailsDrawer/index';
import * as smartStudio_component_workflowManagement_component_editAliasNameModal from '@/pages/smartStudio/component/workflowManagement/component/editAliasNameModal/index';
import * as smartStudio_component_workflowManagement_component_viewVersionDrawer from '@/pages/smartStudio/component/workflowManagement/component/viewVersionDrawer/index';
import * as smartStudio_component_workflowManagement_component_flowDrawerHeader from '@/pages/smartStudio/component/workflowManagement/component/flowDrawerHeader/index';
import * as channelSetting_component_setUpChannel_component_jsApiAuthTable_useDialog from '@/pages/channelSetting/component/setUpChannel/component/jsApiAuthTable/useDialog';
import * as miniAppStore_component_miniAppOnlineStatus_component_channelTable_const from '@/pages/miniAppStore/component/miniAppOnlineStatus/component/channelTable/const';
import * as miniAppStore_component_miniAppOnlineStatus_component_channelTable from '@/pages/miniAppStore/component/miniAppOnlineStatus/component/channelTable/index';
import * as miniAppStore_component_categoryManagement_component_categoryList from '@/pages/miniAppStore/component/categoryManagement/component/categoryList/index';
import * as miniAppStore_component_categoryManagement_component_createDrawer from '@/pages/miniAppStore/component/categoryManagement/component/createDrawer/index';
import * as miniAppStore_setting_component_rightCard_component_editableInput from '@/pages/miniAppStore/setting/component/rightCard/component/editableInput/index';
import * as channelSetting_component_setUpChannel_component_jsApiAuthTable_config from '@/pages/channelSetting/component/setUpChannel/component/jsApiAuthTable/config';
import * as channelSetting_component_setUpChannel_component_jsApiAuthTable from '@/pages/channelSetting/component/setUpChannel/component/jsApiAuthTable/index';
import * as miniAppStore_setting_component_leftList_component_categoryItem from '@/pages/miniAppStore/setting/component/leftList/component/categoryItem/index';
import * as channelSetting_component_setUpChannel_component_editablePane from '@/pages/channelSetting/component/setUpChannel/component/editablePane/index';
import * as miniAppStore_component_categoryManagement_component_dragList from '@/pages/miniAppStore/component/categoryManagement/component/dragList/index';
import * as miniAppStore_setting_component_rightCard_component_addDrawer from '@/pages/miniAppStore/setting/component/rightCard/component/addDrawer/index';
import * as miniAppStore_setting_component_rightCard_component_dragCard from '@/pages/miniAppStore/setting/component/rightCard/component/dragCard/index';
import * as miniAppStore_setting_component_rightCard_component_unsorted from '@/pages/miniAppStore/setting/component/rightCard/component/unsorted/index';
import * as miniapp_detail_component_jsApiFeatures_applyTable_useRowSelection from '@/pages/miniapp/detail/component/jsApiFeatures/applyTable/useRowSelection';
import * as smartStudio_component_monitoringDashboard_graphicComponent from '@/pages/smartStudio/component/monitoringDashboard/graphicComponent/index';
import * as settings_components_documentSetting_components_treeHeader from '@/pages/settings/components/documentSetting/components/treeHeader/index';
import * as channelSetting_component_setUpChannel_component_edit from '@/pages/channelSetting/component/setUpChannel/component/edit/index';
import * as miniapp_detail_component_jsApiFeatures_applyTable_config from '@/pages/miniapp/detail/component/jsApiFeatures/applyTable/config';
import * as miniapp_version_component_release_component_record from '@/pages/miniapp/version/component/release/component/record/index';
import * as miniapp_detail_component_jsApiFeatures_applyTable from '@/pages/miniapp/detail/component/jsApiFeatures/applyTable/index';
import * as miniAppStore_component_miniAppTemplate_template from '@/pages/miniAppStore/component/miniAppTemplate/template/index';
import * as miniapp_detail_component_jsApiFeatures_useApplyDialog from '@/pages/miniapp/detail/component/jsApiFeatures/useApplyDialog';
import * as miniapp_detail_component_MiniappsRedirectURL from '@/pages/miniapp/detail/component/MiniappsRedirectURL/index';
import * as miniapp_detail_component_chooseChannelModal from '@/pages/miniapp/detail/component/chooseChannelModal/index';
import * as miniAppStore_component_miniAppOnlineStatus from '@/pages/miniAppStore/component/miniAppOnlineStatus/index';
import * as miniAppStore_component_categoryManagement from '@/pages/miniAppStore/component/categoryManagement/index';
import * as smartStudio_component_monitoringDashboard_const from '@/pages/smartStudio/component/monitoringDashboard/const';
import * as smartStudio_component_monitoringDashboard from '@/pages/smartStudio/component/monitoringDashboard/index';
import * as miniAppStore_setting_component_rightCard from '@/pages/miniAppStore/setting/component/rightCard/index';
import * as miniapp_detail_component_fileUploadModal from '@/pages/miniapp/detail/component/fileUploadModal/index';
import * as miniapp_detail_component_subVersionTable from '@/pages/miniapp/detail/component/subVersionTable/index';
import * as smartStudio_component_workflowManagement_const from '@/pages/smartStudio/component/workflowManagement/const';
import * as smartStudio_component_workflowManagement from '@/pages/smartStudio/component/workflowManagement/index';
import * as miniAppStore_setting_component_leftList from '@/pages/miniAppStore/setting/component/leftList/index';
import * as miniapp_detail_component_addMemberModal from '@/pages/miniapp/detail/component/addMemberModal/index';
import * as miniapp_detail_component_jsApiFeatures_config from '@/pages/miniapp/detail/component/jsApiFeatures/config';
import * as invitation_component_invitationsRecord_const from '@/pages/invitation/component/invitationsRecord/const';
import * as invitation_component_invitationsRecord from '@/pages/invitation/component/invitationsRecord/index';
import * as miniAppStore_component_miniAppTemplate from '@/pages/miniAppStore/component/miniAppTemplate/index';
import * as miniapp_detail_component_jsApiFeatures from '@/pages/miniapp/detail/component/jsApiFeatures/index';
import * as channelSetting_component_setUpChannel_const from '@/pages/channelSetting/component/setUpChannel/const';
import * as channelSetting_component_setUpChannel from '@/pages/channelSetting/component/setUpChannel/index';
import * as miniAppStore_component_miniAppOperate from '@/pages/miniAppStore/component/miniAppOperate/index';
import * as miniapp_version_component_versionInfo from '@/pages/miniapp/version/component/versionInfo/index';
import * as miniapp_detail_component_information from '@/pages/miniapp/detail/component/information/index';
import * as settings_components_documentSetting from '@/pages/settings/components/documentSetting/index';
import * as approvals_detail_redirectUrl_urlsContent from '@/pages/approvals/detail/redirectUrl/urlsContent';
import * as members_component_addMemberModal_indexCp from '@/pages/members/component/addMemberModal/indexCp';
import * as settings_components_termsAndPolicy from '@/pages/settings/components/termsAndPolicy/index';
import * as miniapp_component_archived_dataArchived from '@/pages/miniapp/component/archived/dataArchived';
import * as miniapp_detail_component_settings from '@/pages/miniapp/detail/component/settings/index';
import * as miniapp_detail_component_versions from '@/pages/miniapp/detail/component/versions/index';
import * as miniapp_version_component_release from '@/pages/miniapp/version/component/release/index';
import * as channelSetting_component_appList from '@/pages/channelSetting/component/appList/index';
import * as miniapp_detail_component_members_const from '@/pages/miniapp/detail/component/members/const';
import * as miniapp_detail_component_members from '@/pages/miniapp/detail/component/members/index';
import * as channelSetting_component_header from '@/pages/channelSetting/component/header/index';
import * as miniapp_component_archivedTable from '@/pages/miniapp/component/archivedTable/index';
import * as login_component_forgotPassword from '@/pages/login/component/forgotPassword/index';
import * as login_component_loginFormsCode from '@/pages/login/component/loginFormsCode/index';
import * as miniapp_component_miniappTable from '@/pages/miniapp/component/miniappTable/index';
import * as overview_component_banner_stepConfig from '@/pages/overview/component/banner/stepConfig';
import * as approvals_component_completed_const from '@/pages/approvals/component/completed/const';
import * as approvals_component_completed from '@/pages/approvals/component/completed/index';
import * as approvals_component_myRequest_const from '@/pages/approvals/component/myRequest/const';
import * as approvals_component_myRequest from '@/pages/approvals/component/myRequest/index';
import * as approvals_detail_redirectUrl_config from '@/pages/approvals/detail/redirectUrl/config';
import * as login_component_privacyPolicy from '@/pages/login/component/privacyPolicy/index';
import * as members_component_invitations_const from '@/pages/members/component/invitations/const';
import * as members_component_invitations from '@/pages/members/component/invitations/index';
import * as miniAppStore_component_header from '@/pages/miniAppStore/component/header/index';
import * as settlein_component_stepC_stepConfig from '@/pages/settlein/component/stepC/stepConfig';
import * as approvals_detail_redirectUrl from '@/pages/approvals/detail/redirectUrl/index';
import * as overview_component_approvals from '@/pages/overview/component/approvals/index';
import * as approvals_component_pending_const from '@/pages/approvals/component/pending/const';
import * as approvals_component_pending from '@/pages/approvals/component/pending/index';
import * as approvals_detail_jsapiAuth_config from '@/pages/approvals/detail/jsapiAuth/config';
import * as invitation_component_header from '@/pages/invitation/component/header/index';
import * as invitation_component_invite from '@/pages/invitation/component/invite/index';
import * as invitation_component_spaces_const from '@/pages/invitation/component/spaces/const';
import * as invitation_component_spaces from '@/pages/invitation/component/spaces/index';
import * as smartStudio_component_empty from '@/pages/smartStudio/component/empty/index';
import * as approvals_component_header from '@/pages/approvals/component/header/index';
import * as approvals_detail_jsapiAuth from '@/pages/approvals/detail/jsapiAuth/index';
import * as login_component_loginForms from '@/pages/login/component/loginForms/index';
import * as members_component_header_indexCp from '@/pages/members/component/header/indexCp';
import * as miniapp_component_archived from '@/pages/miniapp/component/archived/index';
import * as overview_component_miniapp from '@/pages/overview/component/miniapp/index';
import * as overview_component_banner from '@/pages/overview/component/banner/index';
import * as login_component_register from '@/pages/login/component/register/index';
import * as members_component_member_const from '@/pages/members/component/member/const';
import * as members_component_member from '@/pages/members/component/member/index';
import * as miniapp_component_active from '@/pages/miniapp/component/active/index';
import * as settings_components_site from '@/pages/settings/components/site/index';
import * as settlein_component_stepA from '@/pages/settlein/component/stepA/index';
import * as settlein_component_stepB from '@/pages/settlein/component/stepB/index';
import * as settlein_component_stepC from '@/pages/settlein/component/stepC/index';
import * as settlein_component_left from '@/pages/settlein/component/left/index';
import * as approvals_detail_space from '@/pages/approvals/detail/space/index';
import * as approvals_detail_app from '@/pages/approvals/detail/app/index';
import * as miniAppStore_setting from '@/pages/miniAppStore/setting/index';
import * as miniapp_statusDetail from '@/pages/miniapp/statusDetail/index';
import * as platformInfoSettings from '@/pages/platformInfoSettings/index';
import * as approvals_detail from '@/pages/approvals/detail/index';
import * as miniapp_version from '@/pages/miniapp/version/index';
import * as channelSetting from '@/pages/channelSetting/index';
import * as miniapp_detail from '@/pages/miniapp/detail/index';
import * as emas_preview from '@/pages/emas/preview/index';
import * as miniAppStore_const from '@/pages/miniAppStore/const';
import * as miniAppStore from '@/pages/miniAppStore/index';
import * as smartStudio from '@/pages/smartStudio/index';
import * as $bizCode_$ from '@/pages/$bizCode/*/index';
import * as invitation from '@/pages/invitation/index';
import * as approvals from '@/pages/approvals/index';
import * as joinspace from '@/pages/joinspace/index';
import * as overview from '@/pages/overview/index';
import * as register from '@/pages/register/index';
import * as settings from '@/pages/settings/index';
import * as settlein from '@/pages/settlein/index';
import * as members from '@/pages/members/index';
import * as miniapp from '@/pages/miniapp/index';
import * as success from '@/pages/success/index';
import * as waiting from '@/pages/waiting/index';
import * as spaces from '@/pages/spaces/index';
import * as email from '@/pages/email/index';
import * as error from '@/pages/error/index';
import * as login from '@/pages/login/index';
import * as _ from '@/pages/index';

const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode,
}) => ([
  {
    path: '',
    async lazy() {
      ;
      return {
        ...layout,
        Component: () => WrapRouteComponent({
          routeId: 'layout',
          isLayout: true,
          routeExports: layout,
        }),
        loader: createRouteLoader({
          routeId: 'layout',
          requestContext,
          renderMode,
          module: layout,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'layout',
    index: undefined,
    id: 'layout',
    exact: true,
    exports: ["default"],
    layout: true,
    children: [{
      path: 'miniAppStore/setting/component/rightCard/component/dragCard/component/dragAndDropHOC',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_dragCard_component_dragAndDropHOC,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard/component/dragAndDropHOC',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_dragCard_component_dragAndDropHOC,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard/component/dragAndDropHOC',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_dragCard_component_dragAndDropHOC,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-dragcard-component-draganddrophoc-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/dragCard/component/dragAndDropHOC',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard/component/dragCard/component/cardItem',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_dragCard_component_cardItem,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard/component/cardItem',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_dragCard_component_cardItem,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard/component/cardItem',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_dragCard_component_cardItem,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-dragcard-component-carditem-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/dragCard/component/cardItem',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useRowSelection',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_jsApiAuthTable_useRowSelection,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useRowSelection',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_jsApiAuthTable_useRowSelection,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useRowSelection',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_jsApiAuthTable_useRowSelection,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-jsapiauthtable-userowselection',
      index: undefined,
      id: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useRowSelection',
      exact: true,
      exports: ["useRowSelection"],
    },{
      path: 'smartStudio/component/workflowManagement/component/viewFlowDetailsDrawer',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement_component_viewFlowDetailsDrawer,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement/component/viewFlowDetailsDrawer',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement_component_viewFlowDetailsDrawer,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement/component/viewFlowDetailsDrawer',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement_component_viewFlowDetailsDrawer,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-component-viewflowdetailsdrawer-index',
      index: true,
      id: 'smartStudio/component/workflowManagement/component/viewFlowDetailsDrawer',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/workflowManagement/component/editAliasNameModal',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement_component_editAliasNameModal,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement/component/editAliasNameModal',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement_component_editAliasNameModal,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement/component/editAliasNameModal',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement_component_editAliasNameModal,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-component-editaliasnamemodal-index',
      index: true,
      id: 'smartStudio/component/workflowManagement/component/editAliasNameModal',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/workflowManagement/component/viewVersionDrawer',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement_component_viewVersionDrawer,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement/component/viewVersionDrawer',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement_component_viewVersionDrawer,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement/component/viewVersionDrawer',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement_component_viewVersionDrawer,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-component-viewversiondrawer-index',
      index: true,
      id: 'smartStudio/component/workflowManagement/component/viewVersionDrawer',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/workflowManagement/component/flowDrawerHeader',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement_component_flowDrawerHeader,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement/component/flowDrawerHeader',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement_component_flowDrawerHeader,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement/component/flowDrawerHeader',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement_component_flowDrawerHeader,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-component-flowdrawerheader-index',
      index: true,
      id: 'smartStudio/component/workflowManagement/component/flowDrawerHeader',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useDialog',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_jsApiAuthTable_useDialog,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useDialog',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_jsApiAuthTable_useDialog,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useDialog',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_jsApiAuthTable_useDialog,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-jsapiauthtable-usedialog',
      index: undefined,
      id: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/useDialog',
      exact: true,
      exports: ["useAddCustomerJsApiDialog","useDialog"],
    },{
      path: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable/const',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppOnlineStatus_component_channelTable_const,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable/const',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppOnlineStatus_component_channelTable_const,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable/const',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppOnlineStatus_component_channelTable_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniapponlinestatus-component-channeltable-const',
      index: undefined,
      id: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable/const',
      exact: true,
      exports: ["renderCategory","renderCreator","renderId","renderStatus","renderTargetApp","renderTitle","statusFilters"],
    },{
      path: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppOnlineStatus_component_channelTable,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppOnlineStatus_component_channelTable,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppOnlineStatus_component_channelTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniapponlinestatus-component-channeltable-index',
      index: true,
      id: 'miniAppStore/component/miniAppOnlineStatus/component/channelTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/categoryManagement/component/categoryList',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_categoryManagement_component_categoryList,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/categoryManagement/component/categoryList',
          isLayout: false,
          routeExports: miniAppStore_component_categoryManagement_component_categoryList,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/categoryManagement/component/categoryList',
          requestContext,
          renderMode,
          module: miniAppStore_component_categoryManagement_component_categoryList,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-categorymanagement-component-categorylist-index',
      index: true,
      id: 'miniAppStore/component/categoryManagement/component/categoryList',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/categoryManagement/component/createDrawer',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_categoryManagement_component_createDrawer,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/categoryManagement/component/createDrawer',
          isLayout: false,
          routeExports: miniAppStore_component_categoryManagement_component_createDrawer,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/categoryManagement/component/createDrawer',
          requestContext,
          renderMode,
          module: miniAppStore_component_categoryManagement_component_createDrawer,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-categorymanagement-component-createdrawer-index',
      index: true,
      id: 'miniAppStore/component/categoryManagement/component/createDrawer',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard/component/editableInput',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_editableInput,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/editableInput',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_editableInput,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/editableInput',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_editableInput,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-editableinput-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/editableInput',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/config',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_jsApiAuthTable_config,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/config',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_jsApiAuthTable_config,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/config',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_jsApiAuthTable_config,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-jsapiauthtable-config',
      index: undefined,
      id: 'channelSetting/component/setUpChannel/component/jsApiAuthTable/config',
      exact: true,
      exports: ["tableColumons"],
    },{
      path: 'channelSetting/component/setUpChannel/component/jsApiAuthTable',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_jsApiAuthTable,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_jsApiAuthTable,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/jsApiAuthTable',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_jsApiAuthTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-jsapiauthtable-index',
      index: true,
      id: 'channelSetting/component/setUpChannel/component/jsApiAuthTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/leftList/component/categoryItem',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_leftList_component_categoryItem,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/leftList/component/categoryItem',
          isLayout: false,
          routeExports: miniAppStore_setting_component_leftList_component_categoryItem,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/leftList/component/categoryItem',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_leftList_component_categoryItem,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-leftlist-component-categoryitem-index',
      index: true,
      id: 'miniAppStore/setting/component/leftList/component/categoryItem',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/component/editablePane',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_editablePane,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/editablePane',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_editablePane,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/editablePane',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_editablePane,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-editablepane-index',
      index: true,
      id: 'channelSetting/component/setUpChannel/component/editablePane',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/categoryManagement/component/dragList',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_categoryManagement_component_dragList,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/categoryManagement/component/dragList',
          isLayout: false,
          routeExports: miniAppStore_component_categoryManagement_component_dragList,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/categoryManagement/component/dragList',
          requestContext,
          renderMode,
          module: miniAppStore_component_categoryManagement_component_dragList,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-categorymanagement-component-draglist-index',
      index: true,
      id: 'miniAppStore/component/categoryManagement/component/dragList',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard/component/addDrawer',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_addDrawer,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/addDrawer',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_addDrawer,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/addDrawer',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_addDrawer,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-adddrawer-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/addDrawer',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard/component/dragCard',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_dragCard,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_dragCard,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/dragCard',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_dragCard,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-dragcard-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/dragCard',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard/component/unsorted',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard_component_unsorted,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard/component/unsorted',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard_component_unsorted,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard/component/unsorted',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard_component_unsorted,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-component-unsorted-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard/component/unsorted',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures/applyTable/useRowSelection',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures_applyTable_useRowSelection,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable/useRowSelection',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures_applyTable_useRowSelection,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable/useRowSelection',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures_applyTable_useRowSelection,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-applytable-userowselection',
      index: undefined,
      id: 'miniapp/detail/component/jsApiFeatures/applyTable/useRowSelection',
      exact: true,
      exports: ["useRowSelection"],
    },{
      path: 'smartStudio/component/monitoringDashboard/graphicComponent',
      async lazy() {
      ;
      return {
        ...smartStudio_component_monitoringDashboard_graphicComponent,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/monitoringDashboard/graphicComponent',
          isLayout: false,
          routeExports: smartStudio_component_monitoringDashboard_graphicComponent,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/monitoringDashboard/graphicComponent',
          requestContext,
          renderMode,
          module: smartStudio_component_monitoringDashboard_graphicComponent,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-monitoringdashboard-graphiccomponent-index',
      index: true,
      id: 'smartStudio/component/monitoringDashboard/graphicComponent',
      exact: true,
      exports: ["default"],
    },{
      path: 'settings/components/documentSetting/components/treeHeader',
      async lazy() {
      ;
      return {
        ...settings_components_documentSetting_components_treeHeader,
        Component: () => WrapRouteComponent({
          routeId: 'settings/components/documentSetting/components/treeHeader',
          isLayout: false,
          routeExports: settings_components_documentSetting_components_treeHeader,
        }),
        loader: createRouteLoader({
          routeId: 'settings/components/documentSetting/components/treeHeader',
          requestContext,
          renderMode,
          module: settings_components_documentSetting_components_treeHeader,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settings-components-documentsetting-components-treeheader-index',
      index: true,
      id: 'settings/components/documentSetting/components/treeHeader',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/component/edit',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_component_edit,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/component/edit',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_component_edit,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/component/edit',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_component_edit,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-component-edit-index',
      index: true,
      id: 'channelSetting/component/setUpChannel/component/edit',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures/applyTable/config',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures_applyTable_config,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable/config',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures_applyTable_config,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable/config',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures_applyTable_config,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-applytable-config',
      index: undefined,
      id: 'miniapp/detail/component/jsApiFeatures/applyTable/config',
      exact: true,
      exports: ["tableColumons"],
    },{
      path: 'miniapp/version/component/release/component/record',
      async lazy() {
      ;
      return {
        ...miniapp_version_component_release_component_record,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/version/component/release/component/record',
          isLayout: false,
          routeExports: miniapp_version_component_release_component_record,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/version/component/release/component/record',
          requestContext,
          renderMode,
          module: miniapp_version_component_release_component_record,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-version-component-release-component-record-index',
      index: true,
      id: 'miniapp/version/component/release/component/record',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures/applyTable',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures_applyTable,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures_applyTable,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures/applyTable',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures_applyTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-applytable-index',
      index: true,
      id: 'miniapp/detail/component/jsApiFeatures/applyTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/miniAppTemplate/template',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppTemplate_template,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppTemplate/template',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppTemplate_template,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppTemplate/template',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppTemplate_template,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniapptemplate-template-index',
      index: true,
      id: 'miniAppStore/component/miniAppTemplate/template',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures/useApplyDialog',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures_useApplyDialog,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures/useApplyDialog',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures_useApplyDialog,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures/useApplyDialog',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures_useApplyDialog,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-useapplydialog',
      index: undefined,
      id: 'miniapp/detail/component/jsApiFeatures/useApplyDialog',
      exact: true,
      exports: ["useApplyDialog"],
    },{
      path: 'miniapp/detail/component/MiniappsRedirectURL',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_MiniappsRedirectURL,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/MiniappsRedirectURL',
          isLayout: false,
          routeExports: miniapp_detail_component_MiniappsRedirectURL,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/MiniappsRedirectURL',
          requestContext,
          renderMode,
          module: miniapp_detail_component_MiniappsRedirectURL,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-miniappsredirecturl-index',
      index: true,
      id: 'miniapp/detail/component/MiniappsRedirectURL',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/chooseChannelModal',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_chooseChannelModal,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/chooseChannelModal',
          isLayout: false,
          routeExports: miniapp_detail_component_chooseChannelModal,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/chooseChannelModal',
          requestContext,
          renderMode,
          module: miniapp_detail_component_chooseChannelModal,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-choosechannelmodal-index',
      index: true,
      id: 'miniapp/detail/component/chooseChannelModal',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/miniAppOnlineStatus',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppOnlineStatus,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppOnlineStatus',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppOnlineStatus,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppOnlineStatus',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppOnlineStatus,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniapponlinestatus-index',
      index: true,
      id: 'miniAppStore/component/miniAppOnlineStatus',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/categoryManagement',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_categoryManagement,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/categoryManagement',
          isLayout: false,
          routeExports: miniAppStore_component_categoryManagement,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/categoryManagement',
          requestContext,
          renderMode,
          module: miniAppStore_component_categoryManagement,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-categorymanagement-index',
      index: true,
      id: 'miniAppStore/component/categoryManagement',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/monitoringDashboard/const',
      async lazy() {
      ;
      return {
        ...smartStudio_component_monitoringDashboard_const,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/monitoringDashboard/const',
          isLayout: false,
          routeExports: smartStudio_component_monitoringDashboard_const,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/monitoringDashboard/const',
          requestContext,
          renderMode,
          module: smartStudio_component_monitoringDashboard_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-monitoringdashboard-const',
      index: undefined,
      id: 'smartStudio/component/monitoringDashboard/const',
      exact: true,
      exports: ["ChartTitleTypes","TimeSelectOptions"],
    },{
      path: 'smartStudio/component/monitoringDashboard',
      async lazy() {
      ;
      return {
        ...smartStudio_component_monitoringDashboard,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/monitoringDashboard',
          isLayout: false,
          routeExports: smartStudio_component_monitoringDashboard,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/monitoringDashboard',
          requestContext,
          renderMode,
          module: smartStudio_component_monitoringDashboard,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-monitoringdashboard-index',
      index: true,
      id: 'smartStudio/component/monitoringDashboard',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/rightCard',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_rightCard,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/rightCard',
          isLayout: false,
          routeExports: miniAppStore_setting_component_rightCard,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/rightCard',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_rightCard,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-rightcard-index',
      index: true,
      id: 'miniAppStore/setting/component/rightCard',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/fileUploadModal',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_fileUploadModal,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/fileUploadModal',
          isLayout: false,
          routeExports: miniapp_detail_component_fileUploadModal,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/fileUploadModal',
          requestContext,
          renderMode,
          module: miniapp_detail_component_fileUploadModal,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-fileuploadmodal-index',
      index: true,
      id: 'miniapp/detail/component/fileUploadModal',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/subVersionTable',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_subVersionTable,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/subVersionTable',
          isLayout: false,
          routeExports: miniapp_detail_component_subVersionTable,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/subVersionTable',
          requestContext,
          renderMode,
          module: miniapp_detail_component_subVersionTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-subversiontable-index',
      index: true,
      id: 'miniapp/detail/component/subVersionTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/workflowManagement/const',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement_const,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement/const',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement_const,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement/const',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-const',
      index: undefined,
      id: 'smartStudio/component/workflowManagement/const',
      exact: true,
      exports: ["CardTypeList","FilterKeys","GetColumns","RenderTooltip"],
    },{
      path: 'smartStudio/component/workflowManagement',
      async lazy() {
      ;
      return {
        ...smartStudio_component_workflowManagement,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/workflowManagement',
          isLayout: false,
          routeExports: smartStudio_component_workflowManagement,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/workflowManagement',
          requestContext,
          renderMode,
          module: smartStudio_component_workflowManagement,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-workflowmanagement-index',
      index: true,
      id: 'smartStudio/component/workflowManagement',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting/component/leftList',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting_component_leftList,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting/component/leftList',
          isLayout: false,
          routeExports: miniAppStore_setting_component_leftList,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting/component/leftList',
          requestContext,
          renderMode,
          module: miniAppStore_setting_component_leftList,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-component-leftlist-index',
      index: true,
      id: 'miniAppStore/setting/component/leftList',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/addMemberModal',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_addMemberModal,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/addMemberModal',
          isLayout: false,
          routeExports: miniapp_detail_component_addMemberModal,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/addMemberModal',
          requestContext,
          renderMode,
          module: miniapp_detail_component_addMemberModal,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-addmembermodal-index',
      index: true,
      id: 'miniapp/detail/component/addMemberModal',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures/config',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures_config,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures/config',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures_config,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures/config',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures_config,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-config',
      index: undefined,
      id: 'miniapp/detail/component/jsApiFeatures/config',
      exact: true,
      exports: ["tableColumons"],
    },{
      path: 'invitation/component/invitationsRecord/const',
      async lazy() {
      ;
      return {
        ...invitation_component_invitationsRecord_const,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/invitationsRecord/const',
          isLayout: false,
          routeExports: invitation_component_invitationsRecord_const,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/invitationsRecord/const',
          requestContext,
          renderMode,
          module: invitation_component_invitationsRecord_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-invitationsrecord-const',
      index: undefined,
      id: 'invitation/component/invitationsRecord/const',
      exact: true,
      exports: ["columns","renderActionItem","urlEmun"],
    },{
      path: 'invitation/component/invitationsRecord',
      async lazy() {
      ;
      return {
        ...invitation_component_invitationsRecord,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/invitationsRecord',
          isLayout: false,
          routeExports: invitation_component_invitationsRecord,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/invitationsRecord',
          requestContext,
          renderMode,
          module: invitation_component_invitationsRecord,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-invitationsrecord-index',
      index: true,
      id: 'invitation/component/invitationsRecord',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/miniAppTemplate',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppTemplate,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppTemplate',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppTemplate,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppTemplate',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppTemplate,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniapptemplate-index',
      index: true,
      id: 'miniAppStore/component/miniAppTemplate',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/jsApiFeatures',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_jsApiFeatures,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/jsApiFeatures',
          isLayout: false,
          routeExports: miniapp_detail_component_jsApiFeatures,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/jsApiFeatures',
          requestContext,
          renderMode,
          module: miniapp_detail_component_jsApiFeatures,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-jsapifeatures-index',
      index: true,
      id: 'miniapp/detail/component/jsApiFeatures',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/setUpChannel/const',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel_const,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel/const',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel_const,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel/const',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-const',
      index: undefined,
      id: 'channelSetting/component/setUpChannel/const',
      exact: true,
      exports: ["statusEmun"],
    },{
      path: 'channelSetting/component/setUpChannel',
      async lazy() {
      ;
      return {
        ...channelSetting_component_setUpChannel,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/setUpChannel',
          isLayout: false,
          routeExports: channelSetting_component_setUpChannel,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/setUpChannel',
          requestContext,
          renderMode,
          module: channelSetting_component_setUpChannel,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-setupchannel-index',
      index: true,
      id: 'channelSetting/component/setUpChannel',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/miniAppOperate',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_miniAppOperate,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/miniAppOperate',
          isLayout: false,
          routeExports: miniAppStore_component_miniAppOperate,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/miniAppOperate',
          requestContext,
          renderMode,
          module: miniAppStore_component_miniAppOperate,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-miniappoperate-index',
      index: true,
      id: 'miniAppStore/component/miniAppOperate',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/version/component/versionInfo',
      async lazy() {
      ;
      return {
        ...miniapp_version_component_versionInfo,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/version/component/versionInfo',
          isLayout: false,
          routeExports: miniapp_version_component_versionInfo,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/version/component/versionInfo',
          requestContext,
          renderMode,
          module: miniapp_version_component_versionInfo,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-version-component-versioninfo-index',
      index: true,
      id: 'miniapp/version/component/versionInfo',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/information',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_information,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/information',
          isLayout: false,
          routeExports: miniapp_detail_component_information,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/information',
          requestContext,
          renderMode,
          module: miniapp_detail_component_information,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-information-index',
      index: true,
      id: 'miniapp/detail/component/information',
      exact: true,
      exports: ["default"],
    },{
      path: 'settings/components/documentSetting',
      async lazy() {
      ;
      return {
        ...settings_components_documentSetting,
        Component: () => WrapRouteComponent({
          routeId: 'settings/components/documentSetting',
          isLayout: false,
          routeExports: settings_components_documentSetting,
        }),
        loader: createRouteLoader({
          routeId: 'settings/components/documentSetting',
          requestContext,
          renderMode,
          module: settings_components_documentSetting,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settings-components-documentsetting-index',
      index: true,
      id: 'settings/components/documentSetting',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/redirectUrl/urlsContent',
      async lazy() {
      ;
      return {
        ...approvals_detail_redirectUrl_urlsContent,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/redirectUrl/urlsContent',
          isLayout: false,
          routeExports: approvals_detail_redirectUrl_urlsContent,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/redirectUrl/urlsContent',
          requestContext,
          renderMode,
          module: approvals_detail_redirectUrl_urlsContent,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-redirecturl-urlscontent',
      index: undefined,
      id: 'approvals/detail/redirectUrl/urlsContent',
      exact: true,
      exports: ["default"],
    },{
      path: 'members/component/addMemberModal/indexCp',
      async lazy() {
      ;
      return {
        ...members_component_addMemberModal_indexCp,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/addMemberModal/indexCp',
          isLayout: false,
          routeExports: members_component_addMemberModal_indexCp,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/addMemberModal/indexCp',
          requestContext,
          renderMode,
          module: members_component_addMemberModal_indexCp,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-addmembermodal-indexcp',
      index: undefined,
      id: 'members/component/addMemberModal/indexCp',
      exact: true,
      exports: ["default"],
    },{
      path: 'settings/components/termsAndPolicy',
      async lazy() {
      ;
      return {
        ...settings_components_termsAndPolicy,
        Component: () => WrapRouteComponent({
          routeId: 'settings/components/termsAndPolicy',
          isLayout: false,
          routeExports: settings_components_termsAndPolicy,
        }),
        loader: createRouteLoader({
          routeId: 'settings/components/termsAndPolicy',
          requestContext,
          renderMode,
          module: settings_components_termsAndPolicy,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settings-components-termsandpolicy-index',
      index: true,
      id: 'settings/components/termsAndPolicy',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/component/archived/dataArchived',
      async lazy() {
      ;
      return {
        ...miniapp_component_archived_dataArchived,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/component/archived/dataArchived',
          isLayout: false,
          routeExports: miniapp_component_archived_dataArchived,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/component/archived/dataArchived',
          requestContext,
          renderMode,
          module: miniapp_component_archived_dataArchived,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-component-archived-dataarchived',
      index: undefined,
      id: 'miniapp/component/archived/dataArchived',
      exact: true,
      exports: ["dataArchived"],
    },{
      path: 'miniapp/detail/component/settings',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_settings,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/settings',
          isLayout: false,
          routeExports: miniapp_detail_component_settings,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/settings',
          requestContext,
          renderMode,
          module: miniapp_detail_component_settings,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-settings-index',
      index: true,
      id: 'miniapp/detail/component/settings',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/versions',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_versions,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/versions',
          isLayout: false,
          routeExports: miniapp_detail_component_versions,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/versions',
          requestContext,
          renderMode,
          module: miniapp_detail_component_versions,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-versions-index',
      index: true,
      id: 'miniapp/detail/component/versions',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/version/component/release',
      async lazy() {
      ;
      return {
        ...miniapp_version_component_release,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/version/component/release',
          isLayout: false,
          routeExports: miniapp_version_component_release,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/version/component/release',
          requestContext,
          renderMode,
          module: miniapp_version_component_release,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-version-component-release-index',
      index: true,
      id: 'miniapp/version/component/release',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/appList',
      async lazy() {
      ;
      return {
        ...channelSetting_component_appList,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/appList',
          isLayout: false,
          routeExports: channelSetting_component_appList,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/appList',
          requestContext,
          renderMode,
          module: channelSetting_component_appList,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-applist-index',
      index: true,
      id: 'channelSetting/component/appList',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail/component/members/const',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_members_const,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/members/const',
          isLayout: false,
          routeExports: miniapp_detail_component_members_const,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/members/const',
          requestContext,
          renderMode,
          module: miniapp_detail_component_members_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-members-const',
      index: undefined,
      id: 'miniapp/detail/component/members/const',
      exact: true,
      exports: ["miniAppMemberColumns","renderActionItem","urlEmun"],
    },{
      path: 'miniapp/detail/component/members',
      async lazy() {
      ;
      return {
        ...miniapp_detail_component_members,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail/component/members',
          isLayout: false,
          routeExports: miniapp_detail_component_members,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail/component/members',
          requestContext,
          renderMode,
          module: miniapp_detail_component_members,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-component-members-index',
      index: true,
      id: 'miniapp/detail/component/members',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting/component/header',
      async lazy() {
      ;
      return {
        ...channelSetting_component_header,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting/component/header',
          isLayout: false,
          routeExports: channelSetting_component_header,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting/component/header',
          requestContext,
          renderMode,
          module: channelSetting_component_header,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-component-header-index',
      index: true,
      id: 'channelSetting/component/header',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/component/archivedTable',
      async lazy() {
      ;
      return {
        ...miniapp_component_archivedTable,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/component/archivedTable',
          isLayout: false,
          routeExports: miniapp_component_archivedTable,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/component/archivedTable',
          requestContext,
          renderMode,
          module: miniapp_component_archivedTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-component-archivedtable-index',
      index: true,
      id: 'miniapp/component/archivedTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'login/component/forgotPassword',
      async lazy() {
      ;
      return {
        ...login_component_forgotPassword,
        Component: () => WrapRouteComponent({
          routeId: 'login/component/forgotPassword',
          isLayout: false,
          routeExports: login_component_forgotPassword,
        }),
        loader: createRouteLoader({
          routeId: 'login/component/forgotPassword',
          requestContext,
          renderMode,
          module: login_component_forgotPassword,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-component-forgotpassword-index',
      index: true,
      id: 'login/component/forgotPassword',
      exact: true,
      exports: ["default"],
    },{
      path: 'login/component/loginFormsCode',
      async lazy() {
      ;
      return {
        ...login_component_loginFormsCode,
        Component: () => WrapRouteComponent({
          routeId: 'login/component/loginFormsCode',
          isLayout: false,
          routeExports: login_component_loginFormsCode,
        }),
        loader: createRouteLoader({
          routeId: 'login/component/loginFormsCode',
          requestContext,
          renderMode,
          module: login_component_loginFormsCode,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-component-loginformscode-index',
      index: true,
      id: 'login/component/loginFormsCode',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/component/miniappTable',
      async lazy() {
      ;
      return {
        ...miniapp_component_miniappTable,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/component/miniappTable',
          isLayout: false,
          routeExports: miniapp_component_miniappTable,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/component/miniappTable',
          requestContext,
          renderMode,
          module: miniapp_component_miniappTable,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-component-miniapptable-index',
      index: true,
      id: 'miniapp/component/miniappTable',
      exact: true,
      exports: ["default"],
    },{
      path: 'overview/component/banner/stepConfig',
      async lazy() {
      ;
      return {
        ...overview_component_banner_stepConfig,
        Component: () => WrapRouteComponent({
          routeId: 'overview/component/banner/stepConfig',
          isLayout: false,
          routeExports: overview_component_banner_stepConfig,
        }),
        loader: createRouteLoader({
          routeId: 'overview/component/banner/stepConfig',
          requestContext,
          renderMode,
          module: overview_component_banner_stepConfig,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'overview-component-banner-stepconfig',
      index: undefined,
      id: 'overview/component/banner/stepConfig',
      exact: true,
      exports: ["linkToDocument","stepConfig"],
    },{
      path: 'approvals/component/completed/const',
      async lazy() {
      ;
      return {
        ...approvals_component_completed_const,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/completed/const',
          isLayout: false,
          routeExports: approvals_component_completed_const,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/completed/const',
          requestContext,
          renderMode,
          module: approvals_component_completed_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-completed-const',
      index: undefined,
      id: 'approvals/component/completed/const',
      exact: true,
      exports: ["appMemberColumns","renderActionItem"],
    },{
      path: 'approvals/component/completed',
      async lazy() {
      ;
      return {
        ...approvals_component_completed,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/completed',
          isLayout: false,
          routeExports: approvals_component_completed,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/completed',
          requestContext,
          renderMode,
          module: approvals_component_completed,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-completed-index',
      index: true,
      id: 'approvals/component/completed',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/component/myRequest/const',
      async lazy() {
      ;
      return {
        ...approvals_component_myRequest_const,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/myRequest/const',
          isLayout: false,
          routeExports: approvals_component_myRequest_const,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/myRequest/const',
          requestContext,
          renderMode,
          module: approvals_component_myRequest_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-myrequest-const',
      index: undefined,
      id: 'approvals/component/myRequest/const',
      exact: true,
      exports: ["getColumns","renderActionItem"],
    },{
      path: 'approvals/component/myRequest',
      async lazy() {
      ;
      return {
        ...approvals_component_myRequest,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/myRequest',
          isLayout: false,
          routeExports: approvals_component_myRequest,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/myRequest',
          requestContext,
          renderMode,
          module: approvals_component_myRequest,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-myrequest-index',
      index: true,
      id: 'approvals/component/myRequest',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/redirectUrl/config',
      async lazy() {
      ;
      return {
        ...approvals_detail_redirectUrl_config,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/redirectUrl/config',
          isLayout: false,
          routeExports: approvals_detail_redirectUrl_config,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/redirectUrl/config',
          requestContext,
          renderMode,
          module: approvals_detail_redirectUrl_config,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-redirecturl-config',
      index: undefined,
      id: 'approvals/detail/redirectUrl/config',
      exact: true,
      exports: ["tableColumons"],
    },{
      path: 'login/component/privacyPolicy',
      async lazy() {
      ;
      return {
        ...login_component_privacyPolicy,
        Component: () => WrapRouteComponent({
          routeId: 'login/component/privacyPolicy',
          isLayout: false,
          routeExports: login_component_privacyPolicy,
        }),
        loader: createRouteLoader({
          routeId: 'login/component/privacyPolicy',
          requestContext,
          renderMode,
          module: login_component_privacyPolicy,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-component-privacypolicy-index',
      index: true,
      id: 'login/component/privacyPolicy',
      exact: true,
      exports: ["default"],
    },{
      path: 'members/component/invitations/const',
      async lazy() {
      ;
      return {
        ...members_component_invitations_const,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/invitations/const',
          isLayout: false,
          routeExports: members_component_invitations_const,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/invitations/const',
          requestContext,
          renderMode,
          module: members_component_invitations_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-invitations-const',
      index: undefined,
      id: 'members/component/invitations/const',
      exact: true,
      exports: ["columns","renderActionItem","startAcition","urlEmun"],
    },{
      path: 'members/component/invitations',
      async lazy() {
      ;
      return {
        ...members_component_invitations,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/invitations',
          isLayout: false,
          routeExports: members_component_invitations,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/invitations',
          requestContext,
          renderMode,
          module: members_component_invitations,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-invitations-index',
      index: true,
      id: 'members/component/invitations',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/component/header',
      async lazy() {
      ;
      return {
        ...miniAppStore_component_header,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/component/header',
          isLayout: false,
          routeExports: miniAppStore_component_header,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/component/header',
          requestContext,
          renderMode,
          module: miniAppStore_component_header,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-component-header-index',
      index: true,
      id: 'miniAppStore/component/header',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein/component/stepC/stepConfig',
      async lazy() {
      ;
      return {
        ...settlein_component_stepC_stepConfig,
        Component: () => WrapRouteComponent({
          routeId: 'settlein/component/stepC/stepConfig',
          isLayout: false,
          routeExports: settlein_component_stepC_stepConfig,
        }),
        loader: createRouteLoader({
          routeId: 'settlein/component/stepC/stepConfig',
          requestContext,
          renderMode,
          module: settlein_component_stepC_stepConfig,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-component-stepc-stepconfig',
      index: undefined,
      id: 'settlein/component/stepC/stepConfig',
      exact: true,
      exports: ["stepConfig"],
    },{
      path: 'approvals/detail/redirectUrl',
      async lazy() {
      ;
      return {
        ...approvals_detail_redirectUrl,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/redirectUrl',
          isLayout: false,
          routeExports: approvals_detail_redirectUrl,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/redirectUrl',
          requestContext,
          renderMode,
          module: approvals_detail_redirectUrl,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-redirecturl-index',
      index: true,
      id: 'approvals/detail/redirectUrl',
      exact: true,
      exports: ["default"],
    },{
      path: 'overview/component/approvals',
      async lazy() {
      ;
      return {
        ...overview_component_approvals,
        Component: () => WrapRouteComponent({
          routeId: 'overview/component/approvals',
          isLayout: false,
          routeExports: overview_component_approvals,
        }),
        loader: createRouteLoader({
          routeId: 'overview/component/approvals',
          requestContext,
          renderMode,
          module: overview_component_approvals,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'overview-component-approvals-index',
      index: true,
      id: 'overview/component/approvals',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/component/pending/const',
      async lazy() {
      ;
      return {
        ...approvals_component_pending_const,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/pending/const',
          isLayout: false,
          routeExports: approvals_component_pending_const,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/pending/const',
          requestContext,
          renderMode,
          module: approvals_component_pending_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-pending-const',
      index: undefined,
      id: 'approvals/component/pending/const',
      exact: true,
      exports: ["appMemberColumns","renderActionItem"],
    },{
      path: 'approvals/component/pending',
      async lazy() {
      ;
      return {
        ...approvals_component_pending,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/pending',
          isLayout: false,
          routeExports: approvals_component_pending,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/pending',
          requestContext,
          renderMode,
          module: approvals_component_pending,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-pending-index',
      index: true,
      id: 'approvals/component/pending',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/jsapiAuth/config',
      async lazy() {
      ;
      return {
        ...approvals_detail_jsapiAuth_config,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/jsapiAuth/config',
          isLayout: false,
          routeExports: approvals_detail_jsapiAuth_config,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/jsapiAuth/config',
          requestContext,
          renderMode,
          module: approvals_detail_jsapiAuth_config,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-jsapiauth-config',
      index: undefined,
      id: 'approvals/detail/jsapiAuth/config',
      exact: true,
      exports: ["tableColumons"],
    },{
      path: 'invitation/component/header',
      async lazy() {
      ;
      return {
        ...invitation_component_header,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/header',
          isLayout: false,
          routeExports: invitation_component_header,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/header',
          requestContext,
          renderMode,
          module: invitation_component_header,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-header-index',
      index: true,
      id: 'invitation/component/header',
      exact: true,
      exports: ["default"],
    },{
      path: 'invitation/component/invite',
      async lazy() {
      ;
      return {
        ...invitation_component_invite,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/invite',
          isLayout: false,
          routeExports: invitation_component_invite,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/invite',
          requestContext,
          renderMode,
          module: invitation_component_invite,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-invite-index',
      index: true,
      id: 'invitation/component/invite',
      exact: true,
      exports: ["default"],
    },{
      path: 'invitation/component/spaces/const',
      async lazy() {
      ;
      return {
        ...invitation_component_spaces_const,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/spaces/const',
          isLayout: false,
          routeExports: invitation_component_spaces_const,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/spaces/const',
          requestContext,
          renderMode,
          module: invitation_component_spaces_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-spaces-const',
      index: undefined,
      id: 'invitation/component/spaces/const',
      exact: true,
      exports: ["renderActionItem","spacesColumns"],
    },{
      path: 'invitation/component/spaces',
      async lazy() {
      ;
      return {
        ...invitation_component_spaces,
        Component: () => WrapRouteComponent({
          routeId: 'invitation/component/spaces',
          isLayout: false,
          routeExports: invitation_component_spaces,
        }),
        loader: createRouteLoader({
          routeId: 'invitation/component/spaces',
          requestContext,
          renderMode,
          module: invitation_component_spaces,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-component-spaces-index',
      index: true,
      id: 'invitation/component/spaces',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio/component/empty',
      async lazy() {
      ;
      return {
        ...smartStudio_component_empty,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio/component/empty',
          isLayout: false,
          routeExports: smartStudio_component_empty,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio/component/empty',
          requestContext,
          renderMode,
          module: smartStudio_component_empty,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-component-empty-index',
      index: true,
      id: 'smartStudio/component/empty',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/component/header',
      async lazy() {
      ;
      return {
        ...approvals_component_header,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/component/header',
          isLayout: false,
          routeExports: approvals_component_header,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/component/header',
          requestContext,
          renderMode,
          module: approvals_component_header,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-component-header-index',
      index: true,
      id: 'approvals/component/header',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/jsapiAuth',
      async lazy() {
      ;
      return {
        ...approvals_detail_jsapiAuth,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/jsapiAuth',
          isLayout: false,
          routeExports: approvals_detail_jsapiAuth,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/jsapiAuth',
          requestContext,
          renderMode,
          module: approvals_detail_jsapiAuth,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-jsapiauth-index',
      index: true,
      id: 'approvals/detail/jsapiAuth',
      exact: true,
      exports: ["default"],
    },{
      path: 'login/component/loginForms',
      async lazy() {
      ;
      return {
        ...login_component_loginForms,
        Component: () => WrapRouteComponent({
          routeId: 'login/component/loginForms',
          isLayout: false,
          routeExports: login_component_loginForms,
        }),
        loader: createRouteLoader({
          routeId: 'login/component/loginForms',
          requestContext,
          renderMode,
          module: login_component_loginForms,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-component-loginforms-index',
      index: true,
      id: 'login/component/loginForms',
      exact: true,
      exports: ["default"],
    },{
      path: 'members/component/header/indexCp',
      async lazy() {
      ;
      return {
        ...members_component_header_indexCp,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/header/indexCp',
          isLayout: false,
          routeExports: members_component_header_indexCp,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/header/indexCp',
          requestContext,
          renderMode,
          module: members_component_header_indexCp,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-header-indexcp',
      index: undefined,
      id: 'members/component/header/indexCp',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/component/archived',
      async lazy() {
      ;
      return {
        ...miniapp_component_archived,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/component/archived',
          isLayout: false,
          routeExports: miniapp_component_archived,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/component/archived',
          requestContext,
          renderMode,
          module: miniapp_component_archived,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-component-archived-index',
      index: true,
      id: 'miniapp/component/archived',
      exact: true,
      exports: ["default"],
    },{
      path: 'overview/component/miniapp',
      async lazy() {
      ;
      return {
        ...overview_component_miniapp,
        Component: () => WrapRouteComponent({
          routeId: 'overview/component/miniapp',
          isLayout: false,
          routeExports: overview_component_miniapp,
        }),
        loader: createRouteLoader({
          routeId: 'overview/component/miniapp',
          requestContext,
          renderMode,
          module: overview_component_miniapp,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'overview-component-miniapp-index',
      index: true,
      id: 'overview/component/miniapp',
      exact: true,
      exports: ["default"],
    },{
      path: 'overview/component/banner',
      async lazy() {
      ;
      return {
        ...overview_component_banner,
        Component: () => WrapRouteComponent({
          routeId: 'overview/component/banner',
          isLayout: false,
          routeExports: overview_component_banner,
        }),
        loader: createRouteLoader({
          routeId: 'overview/component/banner',
          requestContext,
          renderMode,
          module: overview_component_banner,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'overview-component-banner-index',
      index: true,
      id: 'overview/component/banner',
      exact: true,
      exports: ["default"],
    },{
      path: 'login/component/register',
      async lazy() {
      ;
      return {
        ...login_component_register,
        Component: () => WrapRouteComponent({
          routeId: 'login/component/register',
          isLayout: false,
          routeExports: login_component_register,
        }),
        loader: createRouteLoader({
          routeId: 'login/component/register',
          requestContext,
          renderMode,
          module: login_component_register,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-component-register-index',
      index: true,
      id: 'login/component/register',
      exact: true,
      exports: ["default"],
    },{
      path: 'members/component/member/const',
      async lazy() {
      ;
      return {
        ...members_component_member_const,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/member/const',
          isLayout: false,
          routeExports: members_component_member_const,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/member/const',
          requestContext,
          renderMode,
          module: members_component_member_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-member-const',
      index: undefined,
      id: 'members/component/member/const',
      exact: true,
      exports: ["appMemberColumns","renderActionItem","urlEmun"],
    },{
      path: 'members/component/member',
      async lazy() {
      ;
      return {
        ...members_component_member,
        Component: () => WrapRouteComponent({
          routeId: 'members/component/member',
          isLayout: false,
          routeExports: members_component_member,
        }),
        loader: createRouteLoader({
          routeId: 'members/component/member',
          requestContext,
          renderMode,
          module: members_component_member,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-component-member-index',
      index: true,
      id: 'members/component/member',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/component/active',
      async lazy() {
      ;
      return {
        ...miniapp_component_active,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/component/active',
          isLayout: false,
          routeExports: miniapp_component_active,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/component/active',
          requestContext,
          renderMode,
          module: miniapp_component_active,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-component-active-index',
      index: true,
      id: 'miniapp/component/active',
      exact: true,
      exports: ["default"],
    },{
      path: 'settings/components/site',
      async lazy() {
      ;
      return {
        ...settings_components_site,
        Component: () => WrapRouteComponent({
          routeId: 'settings/components/site',
          isLayout: false,
          routeExports: settings_components_site,
        }),
        loader: createRouteLoader({
          routeId: 'settings/components/site',
          requestContext,
          renderMode,
          module: settings_components_site,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settings-components-site-index',
      index: true,
      id: 'settings/components/site',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein/component/stepA',
      async lazy() {
      ;
      return {
        ...settlein_component_stepA,
        Component: () => WrapRouteComponent({
          routeId: 'settlein/component/stepA',
          isLayout: false,
          routeExports: settlein_component_stepA,
        }),
        loader: createRouteLoader({
          routeId: 'settlein/component/stepA',
          requestContext,
          renderMode,
          module: settlein_component_stepA,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-component-stepa-index',
      index: true,
      id: 'settlein/component/stepA',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein/component/stepB',
      async lazy() {
      ;
      return {
        ...settlein_component_stepB,
        Component: () => WrapRouteComponent({
          routeId: 'settlein/component/stepB',
          isLayout: false,
          routeExports: settlein_component_stepB,
        }),
        loader: createRouteLoader({
          routeId: 'settlein/component/stepB',
          requestContext,
          renderMode,
          module: settlein_component_stepB,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-component-stepb-index',
      index: true,
      id: 'settlein/component/stepB',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein/component/stepC',
      async lazy() {
      ;
      return {
        ...settlein_component_stepC,
        Component: () => WrapRouteComponent({
          routeId: 'settlein/component/stepC',
          isLayout: false,
          routeExports: settlein_component_stepC,
        }),
        loader: createRouteLoader({
          routeId: 'settlein/component/stepC',
          requestContext,
          renderMode,
          module: settlein_component_stepC,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-component-stepc-index',
      index: true,
      id: 'settlein/component/stepC',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein/component/left',
      async lazy() {
      ;
      return {
        ...settlein_component_left,
        Component: () => WrapRouteComponent({
          routeId: 'settlein/component/left',
          isLayout: false,
          routeExports: settlein_component_left,
        }),
        loader: createRouteLoader({
          routeId: 'settlein/component/left',
          requestContext,
          renderMode,
          module: settlein_component_left,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-component-left-index',
      index: true,
      id: 'settlein/component/left',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/space',
      async lazy() {
      ;
      return {
        ...approvals_detail_space,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/space',
          isLayout: false,
          routeExports: approvals_detail_space,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/space',
          requestContext,
          renderMode,
          module: approvals_detail_space,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-space-index',
      index: true,
      id: 'approvals/detail/space',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail/app',
      async lazy() {
      ;
      return {
        ...approvals_detail_app,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail/app',
          isLayout: false,
          routeExports: approvals_detail_app,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail/app',
          requestContext,
          renderMode,
          module: approvals_detail_app,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-app-index',
      index: true,
      id: 'approvals/detail/app',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/setting',
      async lazy() {
      ;
      return {
        ...miniAppStore_setting,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/setting',
          isLayout: false,
          routeExports: miniAppStore_setting,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/setting',
          requestContext,
          renderMode,
          module: miniAppStore_setting,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-setting-index',
      index: true,
      id: 'miniAppStore/setting',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/statusDetail',
      async lazy() {
      ;
      return {
        ...miniapp_statusDetail,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/statusDetail',
          isLayout: false,
          routeExports: miniapp_statusDetail,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/statusDetail',
          requestContext,
          renderMode,
          module: miniapp_statusDetail,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-statusdetail-index',
      index: true,
      id: 'miniapp/statusDetail',
      exact: true,
      exports: ["default"],
    },{
      path: 'platformInfoSettings',
      async lazy() {
      ;
      return {
        ...platformInfoSettings,
        Component: () => WrapRouteComponent({
          routeId: 'platformInfoSettings',
          isLayout: false,
          routeExports: platformInfoSettings,
        }),
        loader: createRouteLoader({
          routeId: 'platformInfoSettings',
          requestContext,
          renderMode,
          module: platformInfoSettings,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'platforminfosettings-index',
      index: true,
      id: 'platformInfoSettings',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals/detail',
      async lazy() {
      ;
      return {
        ...approvals_detail,
        Component: () => WrapRouteComponent({
          routeId: 'approvals/detail',
          isLayout: false,
          routeExports: approvals_detail,
        }),
        loader: createRouteLoader({
          routeId: 'approvals/detail',
          requestContext,
          renderMode,
          module: approvals_detail,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-detail-index',
      index: true,
      id: 'approvals/detail',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/version',
      async lazy() {
      ;
      return {
        ...miniapp_version,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/version',
          isLayout: false,
          routeExports: miniapp_version,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/version',
          requestContext,
          renderMode,
          module: miniapp_version,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-version-index',
      index: true,
      id: 'miniapp/version',
      exact: true,
      exports: ["default"],
    },{
      path: 'channelSetting',
      async lazy() {
      ;
      return {
        ...channelSetting,
        Component: () => WrapRouteComponent({
          routeId: 'channelSetting',
          isLayout: false,
          routeExports: channelSetting,
        }),
        loader: createRouteLoader({
          routeId: 'channelSetting',
          requestContext,
          renderMode,
          module: channelSetting,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'channelsetting-index',
      index: true,
      id: 'channelSetting',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp/detail',
      async lazy() {
      ;
      return {
        ...miniapp_detail,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp/detail',
          isLayout: false,
          routeExports: miniapp_detail,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp/detail',
          requestContext,
          renderMode,
          module: miniapp_detail,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-detail-index',
      index: true,
      id: 'miniapp/detail',
      exact: true,
      exports: ["default"],
    },{
      path: 'emas/preview',
      async lazy() {
      ;
      return {
        ...emas_preview,
        Component: () => WrapRouteComponent({
          routeId: 'emas/preview',
          isLayout: false,
          routeExports: emas_preview,
        }),
        loader: createRouteLoader({
          routeId: 'emas/preview',
          requestContext,
          renderMode,
          module: emas_preview,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'emas-preview-index',
      index: true,
      id: 'emas/preview',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniAppStore/const',
      async lazy() {
      ;
      return {
        ...miniAppStore_const,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore/const',
          isLayout: false,
          routeExports: miniAppStore_const,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore/const',
          requestContext,
          renderMode,
          module: miniAppStore_const,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-const',
      index: undefined,
      id: 'miniAppStore/const',
      exact: true,
      exports: ["Category","UrlEnum","filterKeys","status"],
    },{
      path: 'miniAppStore',
      async lazy() {
      ;
      return {
        ...miniAppStore,
        Component: () => WrapRouteComponent({
          routeId: 'miniAppStore',
          isLayout: false,
          routeExports: miniAppStore,
        }),
        loader: createRouteLoader({
          routeId: 'miniAppStore',
          requestContext,
          renderMode,
          module: miniAppStore,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniappstore-index',
      index: true,
      id: 'miniAppStore',
      exact: true,
      exports: ["default"],
    },{
      path: 'smartStudio',
      async lazy() {
      ;
      return {
        ...smartStudio,
        Component: () => WrapRouteComponent({
          routeId: 'smartStudio',
          isLayout: false,
          routeExports: smartStudio,
        }),
        loader: createRouteLoader({
          routeId: 'smartStudio',
          requestContext,
          renderMode,
          module: smartStudio,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'smartstudio-index',
      index: true,
      id: 'smartStudio',
      exact: true,
      exports: ["default"],
    },{
      path: ':bizCode/*',
      async lazy() {
      ;
      return {
        ...$bizCode_$,
        Component: () => WrapRouteComponent({
          routeId: ':bizCode/*',
          isLayout: false,
          routeExports: $bizCode_$,
        }),
        loader: createRouteLoader({
          routeId: ':bizCode/*',
          requestContext,
          renderMode,
          module: $bizCode_$,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: '$bizcode-*-index',
      index: true,
      id: ':bizCode/*',
      exact: true,
      exports: ["default"],
    },{
      path: 'invitation',
      async lazy() {
      ;
      return {
        ...invitation,
        Component: () => WrapRouteComponent({
          routeId: 'invitation',
          isLayout: false,
          routeExports: invitation,
        }),
        loader: createRouteLoader({
          routeId: 'invitation',
          requestContext,
          renderMode,
          module: invitation,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'invitation-index',
      index: true,
      id: 'invitation',
      exact: true,
      exports: ["default"],
    },{
      path: 'approvals',
      async lazy() {
      ;
      return {
        ...approvals,
        Component: () => WrapRouteComponent({
          routeId: 'approvals',
          isLayout: false,
          routeExports: approvals,
        }),
        loader: createRouteLoader({
          routeId: 'approvals',
          requestContext,
          renderMode,
          module: approvals,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'approvals-index',
      index: true,
      id: 'approvals',
      exact: true,
      exports: ["default"],
    },{
      path: 'joinspace',
      async lazy() {
      ;
      return {
        ...joinspace,
        Component: () => WrapRouteComponent({
          routeId: 'joinspace',
          isLayout: false,
          routeExports: joinspace,
        }),
        loader: createRouteLoader({
          routeId: 'joinspace',
          requestContext,
          renderMode,
          module: joinspace,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'joinspace-index',
      index: true,
      id: 'joinspace',
      exact: true,
      exports: ["default"],
    },{
      path: 'overview',
      async lazy() {
      ;
      return {
        ...overview,
        Component: () => WrapRouteComponent({
          routeId: 'overview',
          isLayout: false,
          routeExports: overview,
        }),
        loader: createRouteLoader({
          routeId: 'overview',
          requestContext,
          renderMode,
          module: overview,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'overview-index',
      index: true,
      id: 'overview',
      exact: true,
      exports: ["default"],
    },{
      path: 'register',
      async lazy() {
      ;
      return {
        ...register,
        Component: () => WrapRouteComponent({
          routeId: 'register',
          isLayout: false,
          routeExports: register,
        }),
        loader: createRouteLoader({
          routeId: 'register',
          requestContext,
          renderMode,
          module: register,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'register-index',
      index: true,
      id: 'register',
      exact: true,
      exports: ["default","getConfig"],
    },{
      path: 'settings',
      async lazy() {
      ;
      return {
        ...settings,
        Component: () => WrapRouteComponent({
          routeId: 'settings',
          isLayout: false,
          routeExports: settings,
        }),
        loader: createRouteLoader({
          routeId: 'settings',
          requestContext,
          renderMode,
          module: settings,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settings-index',
      index: true,
      id: 'settings',
      exact: true,
      exports: ["default"],
    },{
      path: 'settlein',
      async lazy() {
      ;
      return {
        ...settlein,
        Component: () => WrapRouteComponent({
          routeId: 'settlein',
          isLayout: false,
          routeExports: settlein,
        }),
        loader: createRouteLoader({
          routeId: 'settlein',
          requestContext,
          renderMode,
          module: settlein,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'settlein-index',
      index: true,
      id: 'settlein',
      exact: true,
      exports: ["default"],
    },{
      path: 'members',
      async lazy() {
      ;
      return {
        ...members,
        Component: () => WrapRouteComponent({
          routeId: 'members',
          isLayout: false,
          routeExports: members,
        }),
        loader: createRouteLoader({
          routeId: 'members',
          requestContext,
          renderMode,
          module: members,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'members-index',
      index: true,
      id: 'members',
      exact: true,
      exports: ["default"],
    },{
      path: 'miniapp',
      async lazy() {
      ;
      return {
        ...miniapp,
        Component: () => WrapRouteComponent({
          routeId: 'miniapp',
          isLayout: false,
          routeExports: miniapp,
        }),
        loader: createRouteLoader({
          routeId: 'miniapp',
          requestContext,
          renderMode,
          module: miniapp,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'miniapp-index',
      index: true,
      id: 'miniapp',
      exact: true,
      exports: ["default"],
    },{
      path: 'success',
      async lazy() {
      ;
      return {
        ...success,
        Component: () => WrapRouteComponent({
          routeId: 'success',
          isLayout: false,
          routeExports: success,
        }),
        loader: createRouteLoader({
          routeId: 'success',
          requestContext,
          renderMode,
          module: success,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'success-index',
      index: true,
      id: 'success',
      exact: true,
      exports: ["default"],
    },{
      path: 'waiting',
      async lazy() {
      ;
      return {
        ...waiting,
        Component: () => WrapRouteComponent({
          routeId: 'waiting',
          isLayout: false,
          routeExports: waiting,
        }),
        loader: createRouteLoader({
          routeId: 'waiting',
          requestContext,
          renderMode,
          module: waiting,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'waiting-index',
      index: true,
      id: 'waiting',
      exact: true,
      exports: ["default"],
    },{
      path: 'spaces',
      async lazy() {
      ;
      return {
        ...spaces,
        Component: () => WrapRouteComponent({
          routeId: 'spaces',
          isLayout: false,
          routeExports: spaces,
        }),
        loader: createRouteLoader({
          routeId: 'spaces',
          requestContext,
          renderMode,
          module: spaces,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'spaces-index',
      index: true,
      id: 'spaces',
      exact: true,
      exports: [],
    },{
      path: 'email',
      async lazy() {
      ;
      return {
        ...email,
        Component: () => WrapRouteComponent({
          routeId: 'email',
          isLayout: false,
          routeExports: email,
        }),
        loader: createRouteLoader({
          routeId: 'email',
          requestContext,
          renderMode,
          module: email,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'email-index',
      index: true,
      id: 'email',
      exact: true,
      exports: ["default"],
    },{
      path: 'error',
      async lazy() {
      ;
      return {
        ...error,
        Component: () => WrapRouteComponent({
          routeId: 'error',
          isLayout: false,
          routeExports: error,
        }),
        loader: createRouteLoader({
          routeId: 'error',
          requestContext,
          renderMode,
          module: error,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'error-index',
      index: true,
      id: 'error',
      exact: true,
      exports: ["default"],
    },{
      path: 'login',
      async lazy() {
      ;
      return {
        ...login,
        Component: () => WrapRouteComponent({
          routeId: 'login',
          isLayout: false,
          routeExports: login,
        }),
        loader: createRouteLoader({
          routeId: 'login',
          requestContext,
          renderMode,
          module: login,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'login-index',
      index: true,
      id: 'login',
      exact: true,
      exports: ["default"],
    },{
      path: '',
      async lazy() {
      ;
      return {
        ..._,
        Component: () => WrapRouteComponent({
          routeId: '/',
          isLayout: false,
          routeExports: _,
        }),
        loader: createRouteLoader({
          routeId: '/',
          requestContext,
          renderMode,
          module: _,
        }),
      };
    },
      errorElement: <RouteErrorComponent />,
      componentName: 'index',
      index: true,
      id: '/',
      exact: true,
      exports: ["default","jumpToPage"],
    },]
  },
]);
export default createRoutes;
